import React from 'react';  
import { Bar } from 'react-chartjs-2';  
import 'chartjs-adapter-date-fns';  
import { format } from 'date-fns';  
import styled from 'styled-components';  
import ChartDataLabels from 'chartjs-plugin-datalabels';  
import { Chart } from 'chart.js';  
  
Chart.register(ChartDataLabels);  
  
const ChartsContainer = styled.div`  
  background-color: #ffffff;  
  border-radius: 15px;  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  
  padding: 5px;  
  display: flex;  
  flex-direction: column;  
  gap: 20px;  
  overflow-y: auto;  
  max-height: 85vh;  
  width: 100%;  
  min-height: 300px;  
  max-height: 300px;  
  
  @media (max-width: 768px) {  
    width: auto;  
    canvas {  
      height: 500px !important;  
    }  
  }  
`;  
  
const ChartMarketAVGComponent = ({ data }) => {  
  
  const processedData = data.map(item => ({  
    x: new Date(item.TargetDate),  
    y: parseFloat(item.NationalAveragePrice.toFixed(0)), // 小数点以下2桁まで表示  
  }));  
  
  const chartData = {  
    datasets: [  
      {  
        label: '全国平均価格',  
        data: processedData,  
        backgroundColor: 'rgba(0, 128, 0, 0.5)',  
        // borderColor: 'green',  
        // borderWidth: 1,  
      },  
    ],  
  };  
  
  const options = {  
    maintainAspectRatio: false,  
    scales: {  
      x: {  
        type: 'time',  
        time: {  
          unit: 'month', // 月単位に変更  
          tooltipFormat: 'yyyy年-M月', // ツールチップのフォーマットを変更  
          displayFormats: {  
            month: 'yyyy年-M月', // 表示フォーマットを変更  
          },  
        },  
        ticks: {  
          callback: function (value, index, values) {  
            return format(new Date(value), 'yyyy年-M月');  
          },  
        },  
      },  
      y: {  
        title: {  
          display: true,  
          text: '円',  
        },  
      },  
    },  
    plugins: {  
      legend: {  
        position: 'top',  
      },  
      datalabels: {  
        display: function (context) {  
          return context.dataIndex % 20 === 0;  
        },  
        color: 'black',  
        anchor: 'end',  
        align: 'top',  
        formatter: (value, context) => {  
          return value.y ? `${value.y}` : '';  
        },  
      },  
    },  
    layout: {  
      padding: {  
        right: 0,  
        left: 0,  
      },  
    },  
  };  
  
  return (  
    <ChartsContainer>  
      <Bar data={chartData} options={options} />  
    </ChartsContainer>  
  );  
};  
  
export default ChartMarketAVGComponent;  
